import { Message,Loading } from 'element-ui'
const mainfun={
	//禁止滚动条滚动
	unScroll() {
		// 方法一
		var top = $(document).scrollTop();
		$(document).on('scroll.unable',function (e) {
			$(document).scrollTop(top);
		})
		// 方法二
		// document.body.style.position = 'fixed';
		// document.body.style.overflow = 'hidden';
	},
	//移除禁止
	removeUnScroll() {
		// 方法一
		$(document).unbind("scroll.unable");
		// 方法二
		// document.body.style.position = 'relative';
		// document.body.style.overflow = 'auto';
	},
	scrollTop(){
		$('html,body').animate({
			scrollTop: 0
		}, 0); //回到顶端
	},
	//转换年月日方法
	getDate(format,str){  
	    let oDate = new Date(str);  
	    let oYear = oDate.getFullYear();  
	    let oMonth = oDate.getMonth()+1;  
	    let oDay = oDate.getDate(); 
		// let h = oDate.getHours();
		// let mm = oDate.getMinutes();
		// let s = oDate.getSeconds();
	    if(format == 'yyyy-mm-dd'){
	   	    var oTime = oYear +'-'+ this.getzf(oMonth) +'-'+ this.getzf(oDay);//最后拼接时间
	    }else if(format == 'yyyy/mm/dd'){
	    	var oTime = oYear +'/'+ this.getzf(oMonth) +'/'+ this.getzf(oDay);//最后拼接时间
	    }
	    return oTime;  
	 },
	 //补0操作  
	getzf(num){  
	    if(parseInt(num) < 10){  
	        num = '0'+num;  
	    }  
	    return num;  
	 },
}
export{mainfun};








// WEBPACK FOOTER //
// ./src/assets/js/main.js